import Vue from 'vue'

export default (affectedId, comment) =>
  Vue.$http.put(`sinisters/affected/return_from_VR/${affectedId}/`, { comment })



// WEBPACK FOOTER //
// ./src/services/purchase/rejectQuantification.js